import ArticlesSlider from './articles-slider'

export default ArticlesSlider
